/* eslint-disable max-len */
import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    filtersUI: {
        type: 'object',
        title: 'Filters options',
        properties: {
            filterLabel: {
                type: 'string',
                title: 'Enter filter section label',
            },
            showSelectedFilters: {
                type: 'boolean',
                title: 'Show selected filters',
                enum: [true, false],
                default: true,
            },
            clearAllText: {
                type: 'string',
                title: 'Enter text for clear filters',
            },
            appliedText: {
                type: 'string',
                title: 'Enter text for applied filters',
            },
        },
        dependencies: {
            showSelectedFilters: {
                oneOf: [
                    {
                        properties: {
                            showSelectedFilters: {
                                enum: [true],
                            },
                            isCollapsible: {
                                type: 'boolean',
                                title: 'Make selected filters collapsible',
                                enum: [true, false],
                                default: true,
                            },
                        },
                        dependencies: {
                            isCollapsible: {
                                oneOf: [
                                    {
                                        properties: {
                                            isCollapsible: { enum: [true] },
                                            showCollapsibleIcon: {
                                                type: 'boolean',
                                                title: 'Show collapsible icon',
                                                enum: [true, false],
                                            },
                                            showCollapsibleText: {
                                                type: 'boolean',
                                                title: 'Show collpasible text',
                                                enum: [true, false],
                                            },
                                        },
                                        dependencies: {
                                            showCollapsibleIcon: {
                                                oneOf: [
                                                    {
                                                        properties: {
                                                            showCollapsibleIcon: { enum: [true] },
                                                            collapsibleIconPosition: {
                                                                type: 'string',
                                                                title: 'Collapsible Icon position',
                                                                enum: ['Right', 'Left'],
                                                                default: 'Right',
                                                            },
                                                            collapsibleIconType: {
                                                                type: 'string',
                                                                title: 'Collapsible Icon type',
                                                                enum: ['FontAwesome Icon', 'Image'],
                                                                default: 'FontAwesome Icon',
                                                            },
                                                        },
                                                        dependencies: {
                                                            collapsibleIconType: {
                                                                oneOf: [
                                                                    {
                                                                        properties: {
                                                                            collapsibleIconType: {
                                                                                enum: [
                                                                                    `FontAwesome Icon`,
                                                                                ],
                                                                            },
                                                                            collapsibleShowIcon: {
                                                                                type: 'string',
                                                                                title: `Collapsible 
                                                                                Show Icon name`,
                                                                                default:
                                                                                    'fa-chevron-down',
                                                                            },
                                                                            collapsibleHideIcon: {
                                                                                type: 'string',
                                                                                title: `Collapsible 
                                                                                Hide Icon name`,
                                                                                default:
                                                                                    'fa-chevron-up',
                                                                            },
                                                                        },
                                                                    },
                                                                    {
                                                                        properties: {
                                                                            collapsibleIconType: {
                                                                                enum: ['Image'],
                                                                            },
                                                                            collapsibleShowImageUrl:
                                                                                {
                                                                                    type: 'string',
                                                                                    title: `
                                                                                    Collapsible Show
                                                                                    Image url`,
                                                                                },
                                                                            collapsibleHideImageUrl:
                                                                                {
                                                                                    type: 'string',
                                                                                    title: `
                                                                                    Collapsible Hide
                                                                                     Image url`,
                                                                                },
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    },
                                                    {
                                                        properties: {
                                                            showCollapsibleIcon: { enum: [false] },
                                                        },
                                                    },
                                                ],
                                            },
                                            showCollapsibleText: {
                                                oneOf: [
                                                    {
                                                        properties: {
                                                            showCollapsibleText: {
                                                                enum: [true],
                                                            },
                                                            collapsibleTextPosition: {
                                                                type: 'string',
                                                                title: 'Collapsible Text Position',
                                                                enum: ['Right', 'Left'],
                                                                default: 'Right',
                                                            },
                                                            collapsibleShowText: {
                                                                type: 'string',
                                                                title: 'Collapsible Show Text',
                                                            },
                                                            collapsibleHideText: {
                                                                type: 'string',
                                                                title: 'Collapsible Hide Text',
                                                            },
                                                        },
                                                    },
                                                    {
                                                        properties: {
                                                            showCollapsibleText: {
                                                                enum: [false],
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    },
                                    {
                                        properties: {
                                            isCollapsible: { enum: [false] },
                                        },
                                    },
                                ],
                            },
                        },
                    },
                    {
                        properties: {
                            showSelectedFilters: {
                                enum: [false],
                            },
                        },
                    },
                ],
            },
        },
    },
    filters: {
        type: 'array',
        title: 'Add Filters',
        items: {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    title: 'Choose type of filter',
                    enum: [
                        '',
                        'Text',
                        'Dropdown',
                        'Custom Date picker',
                        'Date range picker',
                        'Custom Date range picker',
                    ],
                },
                label: {
                    type: 'string',
                    title: 'Enter filter label',
                },
                placeholder: {
                    type: 'string',
                    title: 'Enter placeholder text',
                },
                analyticsLabel: {
                    type: 'string',
                    title: 'Enter analytics label (Optional)',
                    description: 'Enter label for analytics',
                },
            },
            dependencies: {
                type: {
                    oneOf: [
                        {
                            properties: {
                                type: { enum: ['Text'] },
                                filterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key',
                                    description: 'Key value for filter used in query',
                                },
                                showSearchIcon: {
                                    type: 'boolean',
                                    title: 'Show search icon',
                                    enum: [true, false],
                                    default: false,
                                },
                            },
                            dependencies: {
                                showSearchIcon: {
                                    oneOf: [
                                        {
                                            properties: {
                                                showSearchIcon: { enum: [true] },
                                                searchIconPosition: {
                                                    type: 'string',
                                                    title: 'Choose search icon position',
                                                    enum: ['Right', 'Left'],
                                                    default: 'Right',
                                                },
                                                searchIconType: {
                                                    type: 'string',
                                                    title: 'Choose Icon Type',
                                                    enum: ['FontAwesome Icon', 'Image'],
                                                    default: 'FontAwesome Icon',
                                                },
                                            },
                                            dependencies: {
                                                searchIconType: {
                                                    oneOf: [
                                                        {
                                                            properties: {
                                                                searchIconType: {
                                                                    enum: ['FontAwesome Icon'],
                                                                },
                                                                searchIcon: {
                                                                    type: 'string',
                                                                    title: 'Enter icon name',
                                                                    default: 'fa-search',
                                                                },
                                                            },
                                                        },
                                                        {
                                                            properties: {
                                                                searchIconType: {
                                                                    enum: ['Image'],
                                                                },
                                                                searchImageUrl: {
                                                                    type: 'string',
                                                                    title: 'Enter image url',
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                showSearchIcon: { enum: [false] },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            properties: {
                                type: { enum: ['Dropdown'] },
                                filterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key',
                                    description: 'Key value for filter used in query',
                                },
                                dropdownDataKey: {
                                    type: 'string',
                                    title: 'Enter data key for dropdown items',
                                    description: 'Json path for dropdown data',
                                },
                                displayLabelsKey: {
                                    type: 'string',
                                    title: 'Enter display labels key',
                                    description: 'Key value for display labels',
                                },
                                defaultValue: {
                                    type: 'string',
                                    title: 'Enter default value',
                                    description: 'Default value for dropdown',
                                },
                                dropdownIconType: {
                                    type: 'string',
                                    title: 'Choose dropdown icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                dropdownIconPosition: {
                                    type: 'string',
                                    title: 'Choose dropdown icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                dropdownType: {
                                    type: 'string',
                                    title: 'Choose dropdown type',
                                    enum: ['Single Select', 'Multi Select'],
                                    default: 'Multi Select',
                                },
                            },
                            dependencies: {
                                dropdownIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                dropdownIconType: {
                                                    enum: ['FontAwesome Icon'],
                                                },
                                                dropdownOpenIcon: {
                                                    type: 'string',
                                                    title: 'Enter dropdown open icon name',
                                                },
                                                dropdownCloseIcon: {
                                                    type: 'string',
                                                    title: 'Enter dropdown close icon name',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                dropdownIconType: {
                                                    enum: ['Image'],
                                                },
                                                dropdownOpenImage: {
                                                    type: 'string',
                                                    title: 'Enter dropdown open image url',
                                                },
                                                dropdownCloseImage: {
                                                    type: 'string',
                                                    title: 'Enter dropdown close image url',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            properties: {
                                type: { enum: ['Custom Date picker'] },
                                dateDefaultKey: {
                                    type: 'string',
                                    title: 'Enter default key for date',
                                    description: 'Key value default key for date in date picker',
                                },
                                dateFilterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key for date',
                                    description: 'Key value for filter used in query',
                                },
                                datePickerIconPosition: {
                                    type: 'string',
                                    title: 'Date Picker Icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                datePickerIconType: {
                                    type: 'string',
                                    title: 'Date Picker Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                closeDatePickerIconPosition: {
                                    type: 'string',
                                    title: 'Date Picker Close Icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                closeDatePickerIconType: {
                                    type: 'string',
                                    title: 'Date Picker Close Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                backArrowIconType: {
                                    type: 'string',
                                    title: 'Back Arrow Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                forwardArrowIconType: {
                                    type: 'string',
                                    title: 'Back Arrow Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                datelabel: {
                                    type: 'string',
                                    title: 'Enter date label',
                                    default: 'date',
                                },
                                disableLabelTabIndex: {
                                    type: 'boolean',
                                    title: 'Disable label tab index',
                                },
                                dataKey: {
                                    type: 'string',
                                    title: 'Enter data key',
                                    description: `Enter data key to find minimun
                                    and maximum dates from data for default date.
                                     Note: date must be in yyyy-mm-dd format`,
                                },
                                limitDatekeySelection: {
                                    type: 'string',
                                    title: 'Enter date key for limit date selection',
                                    description: `Enter data key to only select certain dates 
                                    from the data either as a date or dates array.
                                    Note: date must be in yyyy-mm-dd format`,
                                },
                                limitDateMinToMinDate: {
                                    type: 'boolean',
                                    title: `Limit date minimum value to data's minimum date value`,
                                },
                                limitDateMaxToCurrentDate: {
                                    type: 'boolean',
                                    title: `Limit date maximum to current date`,
                                },
                                limitDateMaxToMaxDate: {
                                    type: 'boolean',
                                    title: `Limit date maximum to data's maximum date value`,
                                    description:
                                        'Note-this will only work if "Limit date to current date" is set to false',
                                },
                                limitDateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter limit date error message',
                                    description:
                                        'Limit date error message when its value is not in the data',
                                },
                                dateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter date error message',
                                    description:
                                        'date error message when its value later than to end date',
                                },
                                errorIconPosition: {
                                    type: 'string',
                                    title: 'Error icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                errorIconType: {
                                    type: 'string',
                                    title: 'Choose error icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                            },
                            dependencies: {
                                datePickerIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                datePickerIcon: {
                                                    type: 'string',
                                                    title: `Date 
                                                    Picker Icon name`,
                                                    default: 'fa-calendar',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: ['Image'],
                                                },
                                                datePickerImage: {
                                                    type: 'string',
                                                    title: `
                                                        Date Picker
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                errorIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['FontAwesome Icon'],
                                                },
                                                errorIcon: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search icon name',
                                                    default: 'fa-exclamation-circle',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['Image'],
                                                },
                                                errorImageUrl: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search image url',
                                                },
                                            },
                                        },
                                    ],
                                },
                                closeDatePickerIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                closeDatePickerIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                closeDatePickerIcon: {
                                                    type: 'string',
                                                    title: `Date 
                                                    Picker Close Icon name`,
                                                    default: 'fa-times',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                closeDatePickerIconType: {
                                                    enum: ['Image'],
                                                },
                                                closeDatePickerImage: {
                                                    type: 'string',
                                                    title: `
                                                        Date Picker Close
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                backArrowIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                backArrowIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                backArrowIcon: {
                                                    type: 'string',
                                                    title: `Back Arrow Icon name`,
                                                    default: 'fa-arrow-left',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                backArrowIconType: {
                                                    enum: ['Image'],
                                                },
                                                backArrowImage: {
                                                    type: 'string',
                                                    title: `
                                                        Back Arrow
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                forwardArrowIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                forwardArrowIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                forwardArrowIcon: {
                                                    type: 'string',
                                                    title: `Forward Arrow Icon name`,
                                                    default: 'fa-arrow-right',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                forwardArrowIconType: {
                                                    enum: ['Image'],
                                                },
                                                forwardArrowImage: {
                                                    type: 'string',
                                                    title: `
                                                        Forward Arrow
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            properties: {
                                type: { enum: ['Date range picker'] },
                                startDateFilterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key for start date',
                                    description: 'Key value for filter used in query',
                                },
                                endDateFilterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key for end date',
                                    description: 'Key value for filter used in query',
                                },
                                datePickerIconPosition: {
                                    type: 'string',
                                    title: 'Date Picker Icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                numberOfLettersForTheDays: {
                                    type: 'string',
                                    title: 'Number of letters for the days',
                                    default: '2',
                                },
                                datePickerIconType: {
                                    type: 'string',
                                    title: 'Date Picker Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                dateFormat: {
                                    type: 'string',
                                    title: 'Enter date format',
                                    default: 'MMMM d, yyyy',
                                    description: 'for example- MMMM d, yyyy',
                                },
                                startDatelabel: {
                                    type: 'string',
                                    title: 'Enter start date label',
                                    default: 'Start date',
                                },
                                endDatelabel: {
                                    type: 'string',
                                    title: 'Enter end date label',
                                    default: 'End date',
                                },
                                dataKey: {
                                    type: 'string',
                                    title: 'Enter data key',
                                    description: `Enter data key to find minimun
                                    and maximum dates from data for default start and end dates.
                                     Note: date must be in yyyy-mm-dd format`,
                                },
                                limitDatekeySelection: {
                                    type: 'string',
                                    title: 'Enter date key for limit date selection',
                                    description: `Enter data key to only select certain dates 
                                    from the data either as a date or dates array.
                                    Note: date must be in yyyy-mm-dd format`,
                                },
                                limitStartDateMinToMinDate: {
                                    type: 'boolean',
                                    title: `Limit start date minimum value to data's minimum date value`,
                                },
                                limitStartDateMaxToCurrentDate: {
                                    type: 'boolean',
                                    title: `Limit start date maximum to current date`,
                                },
                                limitStartDateMaxToMaxDate: {
                                    type: 'boolean',
                                    title: `Limit start date maximum to data's maximum date value`,
                                    description:
                                        'Note-this will only work if "Limit start date to current date" is set to false',
                                },
                                limitEndDateMinToStartDate: {
                                    type: 'boolean',
                                    title: `Limit end date minimum value to start date value`,
                                },
                                limitEndDateMaxToCurrentDate: {
                                    type: 'boolean',
                                    title: 'Limit end date maximum value to current date',
                                },
                                limitEndDateMaxToMaxDate: {
                                    type: 'boolean',
                                    title: `Limit end date maximum value to data's maximum date value`,
                                    description:
                                        'Note-this will only work if "Limit end date to current date" is set to false',
                                },
                                startDateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter start date error message',
                                    description:
                                        'Start date error message when its value later than to end date',
                                },
                                endDateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter end date error message',
                                    description:
                                        'End date error message when its value earlier than start date',
                                },
                                errorIconPosition: {
                                    type: 'string',
                                    title: 'Error icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                errorIconType: {
                                    type: 'string',
                                    title: 'Choose error icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                            },
                            dependencies: {
                                datePickerIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                datePickerIcon: {
                                                    type: 'string',
                                                    title: `Date 
                                                    Picker Icon name`,
                                                    default: 'fa-calendar',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: ['Image'],
                                                },
                                                datePickerImage: {
                                                    type: 'string',
                                                    title: `
                                                        Date Picker
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                errorIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['FontAwesome Icon'],
                                                },
                                                errorIcon: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search icon name',
                                                    default: 'fa-exclamation-circle',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['Image'],
                                                },
                                                errorImageUrl: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search image url',
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            properties: {
                                type: { enum: ['Custom Date range picker'] },
                                startDateFilterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key for start date',
                                    description: 'Key value for filter used in query',
                                },
                                endDateFilterByKey: {
                                    type: 'string',
                                    title: 'Enter filter by key for end date',
                                    description: 'Key value for filter used in query',
                                },
                                datePickerIconPosition: {
                                    type: 'string',
                                    title: 'Date Picker Icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                datePickerIconType: {
                                    type: 'string',
                                    title: 'Date Picker Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                closeDatePickerIconPosition: {
                                    type: 'string',
                                    title: 'Date Picker Close Icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                closeDatePickerIconType: {
                                    type: 'string',
                                    title: 'Date Picker Close Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                backArrowIconType: {
                                    type: 'string',
                                    title: 'Back Arrow Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                forwardArrowIconType: {
                                    type: 'string',
                                    title: 'Back Arrow Icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                                startDatelabel: {
                                    type: 'string',
                                    title: 'Enter start date label',
                                    default: 'Start date',
                                },
                                endDatelabel: {
                                    type: 'string',
                                    title: 'Enter end date label',
                                    default: 'End date',
                                },
                                dataKey: {
                                    type: 'string',
                                    title: 'Enter data key',
                                    description: `Enter data key to find minimun
                                    and maximum dates from data for default start and end dates.
                                     Note: date must be in yyyy-mm-dd format`,
                                },
                                limitDatekeySelection: {
                                    type: 'string',
                                    title: 'Enter date key for limit date selection',
                                    description: `Enter data key to only select certain dates 
                                    from the data either as a date or dates array.
                                    Note: date must be in yyyy-mm-dd format`,
                                },
                                limitStartDateMinToMinDate: {
                                    type: 'boolean',
                                    title: `Limit start date minimum value to data's minimum date value`,
                                },
                                limitStartDateMaxToCurrentDate: {
                                    type: 'boolean',
                                    title: `Limit start date maximum to current date`,
                                },
                                limitStartDateMaxToMaxDate: {
                                    type: 'boolean',
                                    title: `Limit start date maximum to data's maximum date value`,
                                    description:
                                        'Note-this will only work if "Limit start date to current date" is set to false',
                                },
                                limitEndDateMinToStartDate: {
                                    type: 'boolean',
                                    title: `Limit end date minimum value to start date value`,
                                },
                                limitEndDateMaxToCurrentDate: {
                                    type: 'boolean',
                                    title: 'Limit end date maximum value to current date',
                                },
                                limitEndDateMaxToMaxDate: {
                                    type: 'boolean',
                                    title: `Limit end date maximum value to data's maximum date value`,
                                    description:
                                        'Note-this will only work if "Limit end date to current date" is set to false',
                                },
                                limitDateStartErrorMessage: {
                                    type: 'string',
                                    title: 'Enter limit Start date error message',
                                    description:
                                        'Limit date error message when its value is not in the data',
                                },
                                limitDateEndErrorMessage: {
                                    type: 'string',
                                    title: 'Enter limit End date error message',
                                    description:
                                        'Limit date error message when its value is not in the data',
                                },
                                startDateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter start date error message',
                                    description:
                                        'Start date error message when its value later than to end date',
                                },
                                endDateErrorMessage: {
                                    type: 'string',
                                    title: 'Enter end date error message',
                                    description:
                                        'End date error message when its value earlier than start date',
                                },
                                errorIconPosition: {
                                    type: 'string',
                                    title: 'Error icon position',
                                    enum: ['Right', 'Left'],
                                    default: 'Right',
                                },
                                errorIconType: {
                                    type: 'string',
                                    title: 'Choose error icon type',
                                    enum: ['FontAwesome Icon', 'Image'],
                                    default: 'FontAwesome Icon',
                                },
                            },
                            dependencies: {
                                datePickerIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                datePickerIcon: {
                                                    type: 'string',
                                                    title: `Date 
                                                    Picker Icon name`,
                                                    default: 'fa-calendar',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                datePickerIconType: {
                                                    enum: ['Image'],
                                                },
                                                datePickerImage: {
                                                    type: 'string',
                                                    title: `
                                                        Date Picker
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                errorIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['FontAwesome Icon'],
                                                },
                                                errorIcon: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search icon name',
                                                    default: 'fa-exclamation-circle',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                errorIconType: {
                                                    enum: ['Image'],
                                                },
                                                errorImageUrl: {
                                                    type: 'string',
                                                    title: 'Enter dropdown search image url',
                                                },
                                            },
                                        },
                                    ],
                                },
                                closeDatePickerIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                closeDatePickerIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                closeDatePickerIcon: {
                                                    type: 'string',
                                                    title: `Date 
                                                    Picker Close Icon name`,
                                                    default: 'fa-times',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                closeDatePickerIconType: {
                                                    enum: ['Image'],
                                                },
                                                closeDatePickerImage: {
                                                    type: 'string',
                                                    title: `
                                                        Date Picker Close
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                backArrowIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                backArrowIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                backArrowIcon: {
                                                    type: 'string',
                                                    title: `Back Arrow Icon name`,
                                                    default: 'fa-arrow-left',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                backArrowIconType: {
                                                    enum: ['Image'],
                                                },
                                                backArrowImage: {
                                                    type: 'string',
                                                    title: `
                                                        Back Arrow
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                                forwardArrowIconType: {
                                    oneOf: [
                                        {
                                            properties: {
                                                forwardArrowIconType: {
                                                    enum: [`FontAwesome Icon`],
                                                },
                                                forwardArrowIcon: {
                                                    type: 'string',
                                                    title: `Forward Arrow Icon name`,
                                                    default: 'fa-arrow-right',
                                                },
                                            },
                                        },
                                        {
                                            properties: {
                                                forwardArrowIconType: {
                                                    enum: ['Image'],
                                                },
                                                forwardArrowImage: {
                                                    type: 'string',
                                                    title: `
                                                        Forward Arrow
                                                        Image url`,
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                    ],
                },
            },
        },
    },
};

const uiSchema = {
    filtersUI: {
        'ui:order': [
            'filterLabel',
            'showSelectedFilters',
            'isCollapsible',
            'showCollapsibleIcon',
            'collapsibleIconPosition',
            'collapsibleIconType',
            'collapsibleShowIcon',
            'collapsibleHideIcon',
            'collapsibleShowImageUrl',
            'collapsibleHideImageUrl',
            'showCollapsibleText',
            'collapsibleTextPosition',
            'collapsibleShowText',
            'collapsibleHideText',
            'clearAllText',
            'appliedText',
            '*',
        ],
        filterLabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{}}' },
        clearAllText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{}}' },
        appliedText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{}}' },
        showSelectedFilters: { 'ui:widget': 'CustomCheckbox' },
        isCollapsible: { 'ui:widget': 'CustomCheckbox' },
        showCollapsibleIcon: { 'ui:widget': 'CustomCheckbox' },
        collapsibleIconPosition: { 'ui:widget': 'CustomSelect' },
        collapsibleIconType: { 'ui:widget': 'CustomSelect' },
        collapsibleShowIcon: { 'ui:widget': 'CustomTextInput' },
        collapsibleHideIcon: { 'ui:widget': 'CustomTextInput' },
        collapsibleShowImageUrl: { 'ui:widget': 'CustomTextInput' },
        collapsibleHideImageUrl: { 'ui:widget': 'CustomTextInput' },
        showCollapsibleText: { 'ui:widget': 'CustomCheckbox' },
        collapsibleShowText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{}}' },
        collapsibleHideText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{}}' },
        collapsibleTextPosition: { 'ui:widget': 'CustomSelect' },
    },
    filters: {
        items: {
            'ui:order': [
                'type',
                'label',
                'placeholder',
                'filterByKey',
                'defaultValue',
                'dateDefaultKey',
                'dateFilterByKey',
                'startDateFilterByKey',
                'endDateFilterByKey',
                'analyticsLabel',
                'showSearchIcon',
                'searchIconPosition',
                'searchIconType',
                'searchIcon',
                'searchImageUrl',
                'dropdownDataKey',
                'displayLabelsKey',
                'dropdownIconPosition',
                'dropdownType',
                'dropdownIconType',
                'dropdownOpenIcon',
                'dropdownCloseIcon',
                'dropdownOpenImage',
                'dropdownCloseImage',
                'enableDDSearch',
                'searchPlaceholder',
                'noOptionFoundText',
                'showDDSearchIcon',
                'serachDDIconPosition',
                'searchDDIconType',
                'searchDDIcon',
                'searchCancelDDIcon',
                'searchDDImageUrl',
                'searchCancelDDImageUrl',
                'hideDDIconSearch',
                'datePickerIconPosition',
                'datePickerIconType',
                'datePickerIcon',
                'datePickerImage',
                'closeDatePickerIconPosition',
                'closeDatePickerIconType',
                'closeDatePickerIcon',
                'closeDatePickerImage',
                'backArrowIconType',
                'backArrowIcon',
                'backArrowImage',
                'forwardArrowIconType',
                'forwardArrowIcon',
                'forwardArrowImage',
                'dateFormat',
                'datelabel',
                'disableLabelTabIndex',
                'startDatelabel',
                'endDatelabel',
                'dataKey',
                'limitDatekeySelection',
                'limitDateMinToMinDate',
                'limitDateMaxToCurrentDate',
                'limitDateMaxToMaxDate',
                'limitDateErrorMessage',
                'dateErrorMessage',
                'limitStartDateMinToMinDate',
                'limitStartDateMaxToCurrentDate',
                'limitStartDateMaxToMaxDate',
                'limitEndDateMinToStartDate',
                'limitEndDateMaxToCurrentDate',
                'limitEndDateMaxToMaxDate',
                'limitDateStartErrorMessage',
                'limitDateEndErrorMessage',
                'startDateErrorMessage',
                'endDateErrorMessage',
                'errorIconPosition',
                'errorIconType',
                'errorIcon',
                'errorImageUrl',
                '*',
            ],
            type: { 'ui:widget': 'CustomSelect' },
            label: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            placeholder: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            filterByKey: { 'ui:widget': 'CustomTextInput' },
            defaultValue: { 'ui:widget': 'CustomTextInput' },
            dateFilterByKey: { 'ui:widget': 'CustomTextInput' },
            dateDefaultKey: { 'ui:widget': 'CustomTextInput' },
            startDateFilterByKey: { 'ui:widget': 'CustomTextInput' },
            endDateFilterByKey: { 'ui:widget': 'CustomTextInput' },
            showSearchIcon: { 'ui:widget': 'CustomCheckbox' },
            searchIconPosition: { 'ui:widget': 'CustomSelect' },
            searchIconType: { 'ui:widget': 'CustomSelect' },
            searchIcon: { 'ui:widget': 'CustomTextInput' },
            searchImageUrl: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            dropdownDataKey: { 'ui:widget': 'CustomTextInput' },
            displayLabelsKey: { 'ui:widget': 'CustomTextInput' },
            dropdownType: { 'ui:widget': 'CustomSelect' },
            dropdownIconType: { 'ui:widget': 'CustomSelect' },
            dropdownOpenIcon: { 'ui:widget': 'CustomTextInput' },
            dropdownCloseIcon: { 'ui:widget': 'CustomTextInput' },
            dropdownIconPosition: { 'ui:widget': 'CustomSelect' },
            dropdownOpenImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            dropdownCloseImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            datePickerIconPosition: { 'ui:widget': 'CustomSelect' },
            numberOfLettersForTheDays: { 'ui:widget': 'CustomTextInput' },
            datePickerIconType: { 'ui:widget': 'CustomSelect' },
            dateFormat: { 'ui:widget': 'CustomTextInput' },
            datelabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            disableLabelTabIndex: { 'ui:widget': 'CustomCheckbox' },
            startDatelabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            endDatelabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            dataKey: { 'ui:widget': 'CustomTextInput' },
            limitDateMinToMinDate: { 'ui:widget': 'CustomCheckbox' },
            limitDateMaxToCurrentDate: { 'ui:widget': 'CustomCheckbox' },
            limitDateMaxToMaxDate: { 'ui:widget': 'CustomCheckbox' },
            limitDateErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            dateErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            limitStartDateMinToMinDate: { 'ui:widget': 'CustomCheckbox' },
            limitStartDateMaxToCurrentDate: { 'ui:widget': 'CustomCheckbox' },
            limitStartDateMaxToMaxDate: { 'ui:widget': 'CustomCheckbox' },
            limitEndDateMinToStartDate: { 'ui:widget': 'CustomCheckbox' },
            limitEndDateMaxToCurrentDate: { 'ui:widget': 'CustomCheckbox' },
            limitEndDateMaxToMaxDate: { 'ui:widget': 'CustomCheckbox' },
            startDateErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            limitDateStartErrorMessage: {
                'ui:widget': 'ResourcePicker',
                'ui:placeholder': '{{ }}',
            },
            limitDateEndErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            endDateErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            errorIconPosition: { 'ui:widget': 'CustomSelect' },
            errorIconType: { 'ui:widget': 'CustomSelect' },
            errorIcon: { 'ui:widget': 'CustomTextInput' },
            errorImageUrl: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            datePickerIcon: { 'ui:widget': 'CustomTextInput' },
            datePickerImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            enableDDSearch: { 'ui:widget': 'CustomCheckbox' },
            searchPlaceholder: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            noOptionFoundText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            showDDSearchIcon: { 'ui:widget': 'CustomCheckbox' },
            serachDDIconPosition: { 'ui:widget': 'CustomSelect' },
            searchDDIconType: { 'ui:widget': 'CustomSelect' },
            searchDDIcon: { 'ui:widget': 'CustomTextInput' },
            searchCancelDDIcon: { 'ui:widget': 'CustomTextInput' },
            searchDDImageUrl: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            searchCancelDDImageUrl: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            hideDDIconSearch: { 'ui:widget': 'CustomCheckbox' },
            analyticsLabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            closeDatePickerIconPosition: { 'ui:widget': 'CustomSelect' },
            closeDatePickerIconType: { 'ui:widget': 'CustomSelect' },
            closeDatePickerIcon: { 'ui:widget': 'CustomTextInput' },
            closeDatePickerImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            backArrowIconType: { 'ui:widget': 'CustomSelect' },
            backArrowIcon: { 'ui:widget': 'CustomTextInput' },
            backArrowImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            forwardArrowIconType: { 'ui:widget': 'CustomSelect' },
            forwardArrowIcon: { 'ui:widget': 'CustomTextInput' },
            forwardArrowImage: {
                'ui:placeholder': 'https://',
                'ui:widget': 'MediaPicker',
                'ui:options': {
                    isImagePicker: true,
                },
            },
            limitDatekeySelection: { 'ui:widget': 'CustomTextInput' },
        },
    },
};

const filtersSchema = {
    schema,
    uiSchema,
};

export default filtersSchema;
